export enum ExceptionDecisionStatus {
    Pay = 'Pay',
    Return = 'Return',
    NA = 'na',
}
